import { BridgeEvent } from 'types/legacy/wireframe';

import { DefaultChatConfig } from '../types';

export const chatConfig: DefaultChatConfig = {
    testingEnvironment: {
        serverAddress: 'https://api.chat.check24-test.de',
        environment: 'test',
    },
    bridgeConfig: {
        product_id: 'package',
        type: BridgeEvent.Event,
        action: null,
        data: null,
        correlation_id: '',
        plugin: 'pr',
    },
    packageConfig: {
        testing: {
            chatFlowName: 'pauschalreise.prod-test',
            chatFlowEntry: 'start',
            chatFlowRelease: 'active',
        },
        production: {
            chatFlowName: 'pauschalreise.production',
            chatFlowEntry: 'start',
            chatFlowRelease: 'active',
        },
    },
    holdingConfig: {
        default: {
            chatFlowName: 'home.welcome',
            chatFlowEntry: 'start_from_home',
            chatFlowRelease: 'active',
        },
        goldClub: {
            chatFlowName: 'home.welcome',
            chatFlowEntry: 'start_from_goldclub',
            chatFlowRelease: 'active',
        },
    },
};
